<template>
  <div id="winlose-member-report" class="container-fluid">
    <div class="page-header mb-1">
      <strong>แพ้-ชนะ สมาชิก/ประเภท</strong>
    </div>
    <b-card no-body class="mb-1 position-relative">
      <b-card-header header-tag="nav">
        <h5 class="card-title">
          <i class="fas fa-exclamation-triangle text-danger mr-2"></i>
          <span class="text-dark mr-2">เฉพาะงวด</span>
          <span class="text-primary mr-2">{{ roundName }}</span>
          <span class="text-dark mr-2">วันที่</span>
          <span class="text-primary mr-2">{{ roundDate }}</span>
          <small class="text-secondary">(เปลี่ยนได้ที่แถบเมนูด้านบน)</small>
        </h5>

        <ol class="breadcrumb px-2 py-1 m-0 mb-2 border-info">
          <li class="breadcrumb-item" v-for="breadcrumb in Breadcrumbs" :class="[{'active': breadcrumb.accountId===parentAccountId}]">
            <span v-if="breadcrumb.accountId===parentAccountId">{{ breadcrumb.username }}</span>
            <a v-else href="#" @click="toggleChildAccount(breadcrumb.accountId)">{{ breadcrumb.username }}</a>
          </li>
        </ol>

        <b-nav card-header tabs>
          <b-nav-item @click="activeTab='ByMember'" :active="activeTab==='ByMember'">แยกตามสมาชิก</b-nav-item>
          <b-nav-item @click="activeTab='ByType'" :active="activeTab==='ByType'">แยกตามประเภท</b-nav-item>
        </b-nav>
      </b-card-header>

      <SetsWinLoseByMember
        v-if="activeTab==='ByMember'"
        :accountId="accountId"
        :rateId="rateId"
        :rates="rates"
        :role="role"
        :reloadCode="byMemberReloadCode"
        @Breadcrumbs="setBreadcrumbs"
        @accountId="toggleChildAccount"
        @setRateId="setRateId"
        @data="setData" />
      <SetsWinLoseByType
        v-else-if="activeTab==='ByType'"
        :agentAccountId="agentAccountId"
        :memberAccountId="memberAccountId"
        :rateId="rateId"
        @Breadcrumbs="setBreadcrumbs"
        @data="setData"
      />

    </b-card>
  </div>
</template>
<script>
import moment from '@/helpers/moment'
import SetsWinLoseByMember from './components/SetsWinLoseByMember'
import SetsWinLoseByType from './components/SetsWinLoseByType'
import cryptoRandomString from 'crypto-random-string'

export default {
  name: 'SetsMemberWinLose',
  components: {
    SetsWinLoseByMember,
    SetsWinLoseByType
  },
  data() {
    return {
      activeTab: 'ByMember',
      data: null,
      accountId: this.$store.state.account._id,
      agentAccountId: this.$store.state.account._id,
      memberAccountId: null,
      Breadcrumbs: [],
      byMemberReloadCode: null,
      rates: [],
      rateId: null,
      role: 'Agent'
    }
  },
  computed: {
    roundName() {
      if(!this.data)
        return ''

      return `[${this.data.round.note.groupTitle}] ${this.data.round.note.marketTitle}`
    },
    roundDate() {
      if(!this.data)
        return ''

      return moment(this.data.round.roundDate.date).format("DD/MM/YYYY")
    },
    currentAccountId() {
      return this.$store.state.account._id
    },
    parentAccountId() {
      if(this.Breadcrumbs.length === 0) {
        return this.currentAccountId
      }else{
        return this.Breadcrumbs[this.Breadcrumbs.length - 1].accountId
      }
    }
  },
  methods: {
    setData(data) {
      this.data = data
      if(!this.rates.length) {
        this.rates = data?.rates ?? []
      }
    },
    toggleChildAccount(accountId, role='Agent', forceReload=false) {
      this.accountId = accountId
      this.role = role

      if(role === 'Member') {
        this.memberAccountId = accountId
      }else{
        this.agentAccountId = accountId
        this.memberAccountId = null
      }

      if(forceReload) {
        this.byMemberReloadCode = cryptoRandomString({length: 10})
      }
    },
    setBreadcrumbs(breadcrumbs) {
      this.Breadcrumbs = breadcrumbs
    },
    setRateId(rateId) {
      this.rateId = rateId
      this.byMemberReloadCode = cryptoRandomString({length: 10})
    }
  },
  mounted() {
    this.accountId = this.$store.state.account._id
  }
}
</script>
